// The register's narrow presentation.
//
// Below the breakpoint the table becomes a horizontally scrolling box, and the column that
// identifies a deal is the first to scroll out of view. A tile shows the same deal without the
// sideways scroll.
//
// The sort control is the substantive part, and is ui/TileSort.jsx: it writes the same URL state
// the headers write, which is why a sort survives a rotation from tiles to table.

import TileSort from '../ui/TileSort.jsx';
import {
  counterpartyLabel,
  directionLabel,
  formatMoney,
  formatPrice,
  stateLabel,
} from './dealForm.js';
import { STAGE_LABELS } from './flow.js';
import { counterparty, dealLink, quantity } from './registerCells.jsx';
import { sortableColumnsFor } from './registerUrl.js';

// `flow` is whether the deal flow is on: a tile then shows the stage where it shows the state.
export default function DealTiles({ flow, deals, query, onSort }) {
  return (
    <>
      <TileSort options={sortableColumnsFor(flow)} query={query} onSort={onSort} />

      <ul className="deal-tiles">
        {deals.map((deal) => (
          <li key={deal.pre_deal_id} className="deal-tile">
            <div className="deal-tile-head">{dealLink(deal)}</div>

            <dl className="deal-tile-fields">
              <Field label="Internal id">{deal.internal_id}</Field>
              {flow
                ? <Field label="Stage">{STAGE_LABELS[deal.stage]}</Field>
                : <Field label="State">{stateLabel(deal.state)}</Field>}
              <Field label="Buy / sell">{directionLabel(deal.direction)}</Field>
              <Field label={counterpartyLabel(deal.direction)}>
                {counterparty(deal.counterparty, deal.counterparty_resolved)}
              </Field>
              <Field label="Product">{deal.product}</Field>
              <Field label="Trader">{deal.trader}</Field>
              <Field label="Volume">{quantity(deal.quantity)}</Field>
              <Field label="Price">{formatPrice(deal.price, deal.quantity?.unit)}</Field>
              <Field label="Value">{formatMoney(deal.value)}</Field>
            </dl>

            <p className="deal-tile-when">
              {new Date(deal.last_activity_at).toLocaleString()}
            </p>
          </li>
        ))}
      </ul>
    </>
  );
}

// An empty field is omitted rather than rendered as a label with nothing after it: on a phone the
// blank rows are most of the tile, and a deal early in its life has almost nothing filled in.
function Field({ label, children }) {
  const empty = children === '' || children === null || children === undefined;
  if (empty) return null;
  return (
    <>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </>
  );
}
